module.exports = __webpack_public_path__ + "img/galerie-33.7a328e59.jpg";